// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"34b2057d","915":"25c4b6f2"}[chunkId] + ".chunk.js";
};